import { GridSortModel } from '@mui/x-data-grid-pro';

const sortValueMapper = {
  asc: 1,
  desc: -1,
};

export const dataGridSortBuilder = (inputSort?: GridSortModel): string => {
  if (inputSort?.length) {
    return inputSort.reduce((query: string, currentValue) => {
      const param = `sort[${currentValue.field}]=${
        sortValueMapper[currentValue.sort || 'asc']
      }`;
      query += query ? `&${param}` : param;
      return query;
    }, '');
  }
  return '';
};
